import { Dispatch } from 'react';
import apis from '../../utils/apis';
import { handleApiError } from './utils/utils';
import { setNotifications, updateNotification as updateNotificationAction, markAllAsRead } from '../../components/Notifications/notificationSlice';

export const GetNotifications = () => async (dispatch: Dispatch<any>) => {
  try {
    // const response: any = await apis({
    //   method: 'GET',
    //   url: '/notifications',
    //   data: {},
    // });

    const response = await apis.get("/notifications")


    if (response && response.status === 200) {
      dispatch(setNotifications(response.data.notifications)); 
      return response;
    } else {
      handleApiError(response, dispatch);
      return null;
    }
  } catch (error) {
    handleApiError(error, dispatch);
  }
};

export const updateNotification = (notification_id: string | number) => async (dispatch: Dispatch<any>) => {
  const id = String(notification_id);


  try {

    const response: any = await apis({
      method: 'POST',
      url: '/notifications/update',
      data: { notification_id: id },
    });


    if (response && response.status === 200) {
      // Pass the string ID to the reducer
      dispatch(updateNotificationAction(id));
      return response;
    } else {
      const errorMessage = response?.data?.message || `Unexpected status: ${response?.status}`;
      handleApiError(response, dispatch);
      return null;
    }
  } catch (error: any) {
    handleApiError(error, dispatch);
    throw error;
  } finally {
  }
};

// Keep these as they don’t directly affect the notifications state
export const markAllNotificationsAsRead = () => async (dispatch: Dispatch<any>) => {
  try {
    const response: any = await apis({
      method: 'POST',
      url: '/notifications/mark-all-read',
    });

    if (response && response.status === 200) {
      dispatch(markAllAsRead());
      return response;
    } else {
      handleApiError(response, dispatch);
      return null;
    }
  } catch (error) {
    handleApiError(error, dispatch);
    return null;
  }
};

export const getNotificationPreferences = () => async (dispatch: Dispatch<any>) => {
  try {

    const response: any = await apis({
      method: 'GET',
      url: '/notifications/preferences',
    });

    if (response && response.status === 200) {
      // Return the preferences object directly
      return response.data.preferences || response.data;
    } else {
      console.error('[getNotificationPreferences] [FAILED] Failed with status:', response?.status);
      handleApiError(response, dispatch);
      return null;
    }
  } catch (error) {
    console.error('[getNotificationPreferences] [FAILED] Exception:', error);
    handleApiError(error, dispatch);
    return null;
  }
};

export const updateNotificationPreferences = (preferencesUpdate: Record<string, any>) => async (dispatch: Dispatch<any>) => {
  try {

    // Send the nested structure directly as the request body
    const response: any = await apis({
      method: 'POST',
      url: '/notifications/preferences',
      data: preferencesUpdate,
    });

    if (response && response.status === 200) {
      return response.data;
    } else {
      console.error('[updateNotificationPreferences] [FAILED] Failed with status:', response?.status);
      handleApiError(response, dispatch);
      return null;
    }
  } catch (error) {
    console.error('[updateNotificationPreferences] [FAILED] Exception:', error);
    handleApiError(error, dispatch);
    return null;
  }
};
